<template>
	<fragment>
		<!-- Filters -->
		<filter-sidebar v-if="filters" v-bind:filters="filters"></filter-sidebar>

		<div class="global-container">
			<section class="section bg-white">
				<div class="row">
					<div v-if="sidebar !== null" class="col-lg-3">
						<side-menu v-bind:sidebar="sidebar"
								   v-bind:hideChildren="sidebarHideChildren"
								   v-bind:header="sidebarHeader"></side-menu>
					</div>
					
					<div v-bind:class="sidebar !== null ? 'col-lg-9' : 'col-lg-12'" v-if="listing.length > 0">
						<section class="cards card--list">
							<div class="global-container">
								<clinical-trial-item v-for="(item, index) in listing"
													 v-bind:item="item"
													 v-bind:displaySummary="displaySummary"
													 v-bind:key="item.DetailID"></clinical-trial-item>
							</div>
						</section>

						<section class="section bg-white" v-if="listing.length > 0 && pagination.totalPages > 1">
							<div class="row">
								<div class="col-12">
									<pagination></pagination>
								</div>
							</div>
						</section>

						<section id="disclaimer-section" v-if="listing.length > 0">
							<div class="row">
								<div class="col-12">
									<disclaimer></disclaimer>
								</div>
							</div>
						</section>

					</div>

					<div class="col-md-9 align-center" v-if="listing.length === 0">
						<h2 class="not-found-heading">Sorry, no trials were found matching your specifications.</h2>
						<p>
							Try removing some filters or searching a different term.
						</p>
					</div>

				</div>
			</section>
		</div>

	</fragment>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
	import SideMenu from '../components/layout/side-menu';
	import SummaryItem from '../components/listing/summary-item';
    import ClinicalTrialItem from '../components/listing/clinical-trial-item';
    import CardItem from '../components/listing/card-item';
	import FilterSidebar from '../components/listing/filter-sidebar';
	import clinicalTrialFilter from '../filters/clinical-trial-filter';
	import * as CONST from '../utils/constants';
	import Disclaimer from '../components/layout/disclaimer';

	export default {
		props: ['filterid', 'filtertype', 'result', 'resource'],
		data: function () {
			return {
				sidebar: CONST.globalProject.SideMenu,
				sidebarHeader: CONST.globalProject.SideMenuHeader,
				sidebarHideChildren: CONST.globalProject.HideSideMenuChildren || false,
                displaySummary: CONST.globalProject.DisplayListingSummary || false,
                displayCardItems: CONST.globalProject.DisplayCardItems || false,
				filters: {}
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		components: {
			pagination: Pagination,
            'clinical-trial-item': ClinicalTrialItem,
            'card-item': CardItem,
			'side-menu': SideMenu,
			'filter-sidebar': FilterSidebar,
			'disclaimer': Disclaimer,
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
			if (this.filtertype === 'clinicalTrialFilter') {
				this.filters = clinicalTrialFilter;
			};

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
        },
    }
</script>